import VIDABOO_CONSTANTS from '../config/consts';
import utilsService from './utilsService';
// import UtilsService from "./utilsService";
const service = {};
const privateState = {};
privateState.widgetInteractionMode =
  VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.TEAM_LIST;
privateState.smallWidgetType = VIDABOO_CONSTANTS.WIDGET_MASK_TYPE.LOGO;
privateState.smallWidgetLocation =
  VIDABOO_CONSTANTS.WIDGET_LOCATION.BOTTOM_RIGHT;
privateState.chatPlaceholderHeight =
  70 + 18; /* 18 is space required by powered by consolto container */
privateState.smallWidgetText = null;
privateState.openWidgetShadowRadiusWidth = 20;
privateState.smallWidgetHeight = 70;
privateState.smallWidgetWidth = 120;
privateState.smallWidgetBottom =
  VIDABOO_CONSTANTS.WIDGET_POSITIONING.DEFAULT_VERTICAL_DISTANCE;
privateState.smallWidgetLeft = 'auto';
privateState.smallWidgetRight =
  VIDABOO_CONSTANTS.WIDGET_POSITIONING.DEFAULT_HORIZONTAL_DISTANCE;
privateState.widgetHorizontalDistance =
  VIDABOO_CONSTANTS.WIDGET_POSITIONING.DEFAULT_HORIZONTAL_DISTANCE;
privateState.widgetVerticalDistance =
  VIDABOO_CONSTANTS.WIDGET_POSITIONING.DEFAULT_VERTICAL_DISTANCE;
privateState.widgetStyleSize = VIDABOO_CONSTANTS.WIDGET_STYLE_SIZE.MEDIUM;
privateState.openWidgetLeft = 'auto';
privateState.openWidgetHeight = 620;
privateState.openWidgetWidth = 360;
privateState.openWidgetIframeHeight =
  privateState.openWidgetHeight + 2 * privateState.openWidgetShadowRadiusWidth;
privateState.openWidgetIframeWidth =
  privateState.openWidgetWidth + 2 * privateState.openWidgetShadowRadiusWidth;
// privateState.openWidgetAnim = 'height 0.4s cubic-bezier(0.075, 0.82, 0.165, 1)';
privateState.openWidgetAnim = 'height 0.3s ease';

const initService = () => {
  if (VIDABOO_CONSTANTS.NATIVE_APP) {
    return;
  }
  window.addEventListener('message', service.receiveMessage, false);

  try {
    window.parent.postMessage(
      {
        getLoc: true,
      },
      '*',
    );
  } catch (e) {
    console.debug('Error:', e);
  }
  privateState.numOfWidgets = 1;
  privateState.multiWidget = false;
  privateState.httpHomePage = null;
  privateState.queueFunctions = [];
  privateState.doWhenTrippleClickFunctions = [];
  privateState.doWhenActionClickFunctions = {};
  privateState.doWhenCredentialFunctions = {}; // Embedded SSO

  privateState.pageLocation = null;
  privateState.sizeInitiators = {};
};
service.setMultiWidget = (isMultiWidget) => {
  privateState.multiWidget = isMultiWidget;
};
service.setWidgetLocation = () => {
  let {
    smallWidgetLocation,
    smallWidgetWidth,
    openWidgetWidth,
    widgetHorizontalDistance,
    widgetVerticalDistance,
  } = privateState;

  switch (smallWidgetLocation) {
    case VIDABOO_CONSTANTS.WIDGET_LOCATION.BOTTOM_LEFT: {
      privateState.smallWidgetRight = 'unset';
      privateState.smallWidgetLeft = `${widgetHorizontalDistance}px`;
      privateState.openWidgetLeft = `${widgetHorizontalDistance}px`;
      privateState.smallWidgetBottom = `${widgetVerticalDistance}px`;
      break;
    }
    case VIDABOO_CONSTANTS.WIDGET_LOCATION.BOTTOM_CENTER: {
      const centerCalc = `calc((100% - ${smallWidgetWidth}px) / 2)`;
      privateState.smallWidgetRight = centerCalc;
      privateState.smallWidgetLeft = 'unset';
      privateState.openWidgetLeft = `calc((100% - ${openWidgetWidth}px) / 2)`;
      privateState.smallWidgetBottom = `${widgetVerticalDistance}px`;
      break;
    }
    case VIDABOO_CONSTANTS.WIDGET_LOCATION.BOTTOM_RIGHT: {
      privateState.smallWidgetRight = `${widgetHorizontalDistance}px`;
      privateState.smallWidgetLeft = 'auto';
      privateState.openWidgetLeft = 'auto';
      privateState.smallWidgetBottom = `${widgetVerticalDistance}px`;
      break;
    }
  }
};
service.setWidgetInfo = (widgetInfo) => {
  const {
    widgetInteractionMode,
    closedWidgetType,
    locationOnScreen,
    widgetMaskText,
    widgetHorizontalDistance,
    widgetVerticalDistance,
    widgetSize,
  } = widgetInfo;

  privateState.widgetInteractionMode = widgetInteractionMode;
  privateState.smallWidgetType = closedWidgetType;
  privateState.smallWidgetLocation = locationOnScreen;
  privateState.smallWidgetText = widgetMaskText;

  if (widgetSize) {
    privateState.widgetStyleSize = widgetSize;
  }

  privateState.widgetHorizontalDistance =
    widgetHorizontalDistance ??
    VIDABOO_CONSTANTS.WIDGET_POSITIONING.DEFAULT_HORIZONTAL_DISTANCE;
  privateState.widgetVerticalDistance =
    widgetVerticalDistance ??
    VIDABOO_CONSTANTS.WIDGET_POSITIONING.DEFAULT_VERTICAL_DISTANCE;

  const {width, height} = utilsService.getWidgetMaskDimension(
    closedWidgetType,
    widgetMaskText,
  );
  privateState.smallWidgetWidth = Math.round(width); // the mask use to move a little bit in LETS_TALK mode with BOTTOM_CENTER due to digits after decimal, so we need to use rounded value here
  privateState.smallWidgetHeight = height;
  service.setWidgetLocation();
};
service.getSmallWidgetText = () => privateState.smallWidgetText;
service.setSmallWidgetText = (smallWidgetText) => {
  privateState.smallWidgetText = smallWidgetText;
};
service.receiveMessage = (evt) => {
  if (evt.data.expertips_iframe === true) {
    if (evt.data.pageLocation) {
      privateState.pageLocation = evt.data.pageLocation;
      privateState.docProtocol = privateState.pageLocation.protocol + '//';
      service.setHomePage();

      while (privateState.queueFunctions.length > 0) {
        const styles = privateState.queueFunctions.pop(); // currently implementing this only for postMessageGeneric which gets styles as a parameter.
        // console.debug('postMessagePop');
        service.postMessageGeneric(styles);
      }
      // once we get the page location, we need to trigger functions that are activated by pageLocation (scheduleLink, callLink)
    } else if (evt.data.trippleClick) {
      privateState.doWhenTrippleClickFunctions.forEach((callbackFunction) => {
        callbackFunction();
      });
    } else if (evt.data.actionClick) {
      const callbackFunctions = Object.values(
        privateState.doWhenActionClickFunctions,
      );
      callbackFunctions &&
        callbackFunctions.forEach((callbackFunction) => {
          callbackFunction(JSON.parse(evt.data.actionClick));
        });
    } else if (evt.data.dataRequest) {
      // data api
      const dataObj = {
        agentStats: privateState.getPeerStatus && privateState.getPeerStatus(),
      };
      service.sendDataToHost(dataObj);
    } else if (evt.data.credentials) {
      // Embedded SSO
      const callbackFunctions = Object.values(
        privateState.doWhenCredentialFunctions,
      );
      callbackFunctions &&
        callbackFunctions.forEach((callbackFunction) => {
          callbackFunction(JSON.parse(evt.data.credentials));
        });
    }
  }
};

service.getLocation = () => {
  return privateState.pageLocation;
};

service.setHomePage = (/* homePage */) => {
  // var httpPattern = /^((http):\/\/)/;
  // var httpsPattern = /^((https):\/\/)/;
  // if (httpPattern.test(homePage)) {
  //      privateState.httpHomePage = homePage.replace(httpPattern,  privateState.docProtocol);
  // }
  // else if (httpsPattern.test(homePage)) {
  //      privateState.httpHomePage = homePage.replace(httpsPattern,  privateState.docProtocol);
  // }
  // else if (this.docProtocol !== undefined) {
  //      privateState.httpHomePage =  privateState..docProtocol + homePage;
  // }
  // else if (this.docProtocol === undefined) {
  //      privateState.httpHomePage = undefined;
  // }
  // if (privateState.pageLocation)
  privateState.httpHomePage = privateState.pageLocation?.hostUrl;
  // else {
  //   privateState.httpHomePage = undefined;
  // }
};
service.setNumOfWidgets = function (num) {
  privateState.numOfWidgets = num;
  if (
    service.getWidgetSize() ===
    VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN
  ) {
    service.postMessageResize(service.getWidgetSize(), '_self');
  }
};

privateState.setWidgetSize = (size) => {
  privateState._widgetSize = size;
};
service.getWidgetSize = () => {
  return privateState._widgetSize;
};
service.postMessageResize = (size, initiator, data) => {
  privateState.sizeInitiators[initiator] = size;
  // console.debug(privateState.sizeInitiators);
  let styles = {};
  // const sizeInitiatorsKeys = Object.keys(privateState.sizeInitiators);
  // let targetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED_TINY;
  // for (var index = 0; index < sizeInitiatorsKeys.length; index++) {
  //   // console.debug('keys: ' + sizeInitiatorsKeys[index]);
  //   if (
  //     privateState.sizeInitiators[sizeInitiatorsKeys[index]] ===
  //     VIDABOO_CONSTANTS.WIDGET_SIZE.LARGE
  //   ) {
  //     targetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.LARGE;
  //     break;
  //   } else if (
  //     privateState.sizeInitiators[sizeInitiatorsKeys[index]] ===
  //     VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN
  //   ) {
  //     targetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN;
  //   } else if (
  //     privateState.sizeInitiators[sizeInitiatorsKeys[index]] ===
  //     VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED
  //   ) {
  //     if (targetSize !== VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN)
  //       targetSize = VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED;
  //   }
  // }
  // console.debug(UtilsService.getCurrentLocation().match("/multiWidget/"));
  let targetSize = size;
  const isInMobile = utilsService.isMobileDevice(); //todomcss : Ilan? -> fix using windowScreenSize

  privateState.setWidgetSize(targetSize);
  styles = {};
  if (targetSize === VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED) {
    const isMaskTextVisible = data?.isMaskTextVisible;
    const shouldIncludeTextInWidth = isMaskTextVisible;
    const {height, width} = utilsService.getWidgetMaskDimension(
      privateState.smallWidgetType,
      shouldIncludeTextInWidth ? service.getSmallWidgetText() : null,
    );
    styles.height = height + 'px';
    styles.width = width + 'px';
    styles.right = privateState.smallWidgetRight;
    styles.left = privateState.smallWidgetLeft;
    // styles.position = 'fixed';
    styles.bottom = privateState.smallWidgetBottom;
    styles.top = 'auto';
    styles['transition'] = 'none';
    const scaleFactor = utilsService.getWidgetMaskScaleFactor(
      privateState.widgetStyleSize,
    );
    const transformOrigin = utilsService.getWidgetMaskTransformOrigin(
      privateState.smallWidgetLocation,
    );
    styles.transform = `scale(${scaleFactor})`;
    styles.transformOrigin = transformOrigin;
  } else if (targetSize === VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_CLOSED_TINY) {
    styles.height = privateState.smallWidgetHeight + 'px';
    // if (privateState.multiWidget)
    //   styles.height = privateState.numOfWidgets * 65 + "px";
    styles.width = privateState.smallWidgetWidth + 'px';
    styles.position = 'fixed';
    styles.bottom = privateState.smallWidgetBottom;
    styles.right = isInMobile ? 'auto' : privateState.smallWidgetRight;
    styles.top = 'auto';
    styles.left = isInMobile ? 'auto' : privateState.smallWidgetLeft;
    styles['transition'] = 'none';
    styles.transform = 'none';
    styles.transformOrigin = 'initial';
  } else if (targetSize === VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN) {
    styles.height = isInMobile
      ? '100%'
      : privateState.openWidgetIframeHeight + 'px';
    styles.width = isInMobile
      ? '100%'
      : privateState.openWidgetIframeWidth + 'px';
    styles.position = 'fixed';
    styles.bottom = isInMobile ? '0' : privateState.smallWidgetBottom;
    styles.right = isInMobile ? '0' : privateState.smallWidgetRight;
    styles.top = 'auto';
    styles.left = isInMobile ? '0' : privateState.openWidgetLeft;
    styles['max-height'] = isInMobile ? 'none' : 'calc(100vh - 50px)';
    styles['transition'] = privateState.openWidgetAnim;
    styles.transform = 'none';
    styles.transformOrigin = 'initial';
  } else if (targetSize === VIDABOO_CONSTANTS.WIDGET_SIZE.ACCOUNT_WIDGET_OPEN) {
    styles.position = 'fixed';
    styles.bottom = isInMobile ? '0' : privateState.smallWidgetBottom;
    styles.right = isInMobile ? 'auto' : privateState.smallWidgetRight;
    styles.top = 'auto';
    styles.left = isInMobile ? '0px' : privateState.openWidgetLeft;
    styles['max-height'] = isInMobile ? 'none' : 'calc(100vh - 50px)';
    styles['transition'] = privateState.openWidgetAnim;
    styles.transform = 'none';
    styles.transformOrigin = 'initial';
    if (privateState.multiWidget) {
      let multiWidgetMaxHeight = privateState.numOfWidgets * (74 + 8) + 172; // 74 is height of each widget's row and 8 is gap between those rows and 172 is remaining space required

      if (
        privateState.widgetInteractionMode ===
        VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT
      ) {
        multiWidgetMaxHeight =
          multiWidgetMaxHeight + privateState.chatPlaceholderHeight;
      }

      if (multiWidgetMaxHeight > privateState.openWidgetHeight) {
        multiWidgetMaxHeight = privateState.openWidgetIframeHeight;
      }
      styles.height = multiWidgetMaxHeight + 'px';
      styles.width = isInMobile
        ? '100%'
        : privateState.openWidgetIframeWidth + 'px';
    }
  } else if (targetSize === VIDABOO_CONSTANTS.WIDGET_SIZE.LARGE) {
    styles.height = '100%';
    styles.width = '100%';
    styles.position = 'fixed';
    styles.top = '0';
    styles.left = '0';
    styles.bottom = 'auto';
    styles.right = '0';
    styles['max-height'] = 'none';
    styles['transition'] = 'none';
    styles.transform = 'none';
    styles.transformOrigin = 'initial';
  } else if (targetSize === VIDABOO_CONSTANTS.WIDGET_SIZE.ACTION_SELECTOR) {
    styles.height = data?.foregroundWidgetsLength // 52 is height of each foreground widget's row and 8 is gap between those rows
      ? 52 * data.foregroundWidgetsLength +
        (data.foregroundWidgetsLength - 1) * 8 +
        privateState.openWidgetShadowRadiusWidth +
        152 +
        65
      : privateState.openWidgetIframeHeight;
    if (data?.actionSelectorHeaderText?.length > 64) {
      styles.height = styles.height + 36;
    } else if (data?.actionSelectorHeaderText?.length > 32) {
      styles.height = styles.height + 18;
    }
    styles.height = isInMobile ? '100%' : styles.height + 'px';
    styles.width = isInMobile
      ? '100%'
      : privateState.openWidgetIframeWidth + 'px';
    styles.position = 'fixed';
    styles.bottom = isInMobile ? '0' : privateState.smallWidgetBottom;
    styles.right = isInMobile ? '0' : privateState.smallWidgetRight;
    styles.top = 'auto';
    styles.left = isInMobile ? '0' : privateState.openWidgetLeft;
    styles['max-height'] = isInMobile ? 'none' : 'calc(100vh - 50px)';
    styles['transition'] = privateState.openWidgetAnim;
    styles.transform = 'none';
    styles.transformOrigin = 'initial';
  }
  service.postMessageGeneric(styles);
};
service.postMessageHide = (visibility) => {
  const display = visibility === 'hidden' ? 'none' : '';
  const styles = {display: display};
  service.postMessageGeneric(styles);
};

service.postMessageGeneric = (styles) => {
  if (
    privateState.httpHomePage === undefined ||
    privateState.httpHomePage === null
  ) {
    privateState.queueFunctions.push(styles); // in case we still didn't get the home from the parent window
    // console.debug('postMessagePush');

    return;
  }
  try {
    window.parent.postMessage(
      {
        styler: true,
        styles: styles,
      },
      privateState.httpHomePage,
    );
  } catch (e) {
    console.debug('postMessageGeneric');
    console.debug(e);
  }
};
service.doWhenTrippleClick = (callbackFunction) => {
  privateState.doWhenTrippleClickFunctions.push(callbackFunction);
};

service.postAnalyticsEvent = (analyticsObj) => {
  try {
    if (privateState.httpHomePage) {
      window.parent.postMessage(
        {
          anlytics: true,
          analyticsObj: analyticsObj,
        },
        privateState.httpHomePage,
      );
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.debug('postAnalyticsEvent');
    console.debug(e);
    return false;
  }
};
service.doWhenActionClick = (callbackFunction) => {
  const callBackFunctions = privateState.doWhenActionClickFunctions;
  const callbackFunctionId =
    new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
  callBackFunctions[callbackFunctionId] = callbackFunction;

  // Telling iframeApp.js, that it is ready to capture url actions
  window.parent.postMessage(
    {
      widgetReadyToRcvActions: true,
    },
    '*',
  );
  return () => {
    delete privateState.doWhenActionClickFunctions[callbackFunctionId];
  };
};

service.registerPeerStatusCallback = (callback) => {
  privateState.getPeerStatus = callback;
};
service.doWhenReceiveCreds = (callbackFunction) => {
  // Embedded SSO
  const callBackFunctions = privateState.doWhenCredentialFunctions;
  const callbackFunctionId =
    new Date().getTime() + '_' + Math.floor(Math.random() * 1e8);
  callBackFunctions[callbackFunctionId] = callbackFunction;

  try {
    window.parent.postMessage(
      {
        backofficeReadyToRcvCreds: true,
      },
      '*',
    );
  } catch (e) {
    console.debug('doWhenReceiveCreds');
    console.debug(e);
  }

  return () => {
    delete privateState.doWhenCredentialFunctions[callbackFunctionId];
  };
};
service.sendEventToHost = (eventObj) => {
  try {
    window.parent.postMessage(
      {
        consoltoEvent: true,
        consoltoEventObj: eventObj,
      },
      privateState.httpHomePage,
    );
  } catch (e) {
    console.debug('error in: sendEventToHost');
    console.debug(e);
  }
};
service.sendDataToHost = (dataApiObj) => {
  try {
    window.parent.postMessage(
      {
        dataResponse: true,
        dataApiObj: dataApiObj,
      },
      privateState.httpHomePage,
    );
  } catch (e) {
    console.debug('error in: sendDataToHost');
    console.debug(e);
  }
};

service.getHomePage = () => privateState.httpHomePage;
initService();
const postMessageService = {...service};
export default postMessageService;
